import React from "react";
import {useSelector} from 'react-redux';
import Logo from "../img/logo/boogiee.svg";
import {Link} from 'react-router-dom';
const Navbar = ()=>{
    const isLoggedIn = useSelector((state) => state.user.auth.isLoggedIn);
    return(
      isLoggedIn?
      <div>
          <h1>Hello World</h1>
      </div>
      :(
        <nav className="navbar-container app-bg-dark">
           <div className="app-logo">
           <a href="/"><img src={Logo} alt="Boogiee Logo" className="logo-img"/></a>
           </div>
           <ul className="app-nav">
            <li><a href="/" className="app-text-white">Live</a></li>
            <li><a href="/" className="app-text-white">Music</a></li>
            <li><a href="/" className="app-text-white">Charts</a></li>
            <li><a href="/" className="app-text-white">Pricing</a></li>
            <li><a href="/" className="app-text-white">Download</a></li>
            <span className="px-3"></span>
            <li><a href="/signin" className="app-text-white">Sign in</a></li>
            <li><Link to="/join" className="app-text-white">Get Started</Link></li>
           </ul>
        </nav>
      )
    );
}

export default Navbar;